'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _intlProviderWrapper = require('./intl-provider-wrapper');

var _intlProviderWrapper2 = _interopRequireDefault(_intlProviderWrapper);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumericalRating = function NumericalRating(props) {
    var rate = props.rate,
        maxRate = props.maxRate,
        intl = props.intl;

    var formattedAverageRate = parseFloat(parseFloat(rate).toFixed(1));

    var styles = props.classNames ? (0, _extends3.default)({}, _style2.default, props.classNames) : _style2.default;
    var className = [styles["numerical-rating-count"]];
    if (props.isCountBold) {
        className.push(styles["text-bold"]);
    }

    var middleSpan = props.isSlash ? '/' : ' ' + intl.formatMessage({ id: 'NumericalRating.out_of' }) + ' ';

    className = className.join(" ");
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'span',
            { className: className },
            formattedAverageRate,
            middleSpan,
            maxRate
        )
    );
};

NumericalRating.propTypes = {
    rate: _propTypes2.default.number,
    maxRate: _propTypes2.default.number,
    isCountBold: _propTypes2.default.bool,
    isSlash: _propTypes2.default.bool
};

NumericalRating.defaultProps = {
    maxRate: 5,
    isCountBold: false
};

exports.default = (0, _intlProviderWrapper2.default)(NumericalRating);